<template lang="pug">
include /mixins
+b.participant-img-loader-wrapper(
  @dragover.prevent="handleDragOver"
  @drop.prevent="handleDrop"
  @dragenter.prevent
  @dragleave="handleDragLeave"
)
  input(type='file' accept="image/*" :id='name' @input='handleDrop')
  +b.participant-img-loader(
    :class='{ "is-active": localImage }'
  )
    +e.img-wrap(
      v-if='localImage'
    )
      +e.img.IMG(
        :src='localImage',
      )
    +e.content(
      v-else
    )
      +e.icon.SVG(width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
        path(d="M14.9995 2H5.5C4.67157 2 4 2.67157 4 3.5V20.5C4 21.3284 4.67157 22 5.5 22H18.5C19.3284 22 20 21.3284 20 20.5V7.49902M14.9995 2V5.99902C14.9995 6.82745 15.6711 7.49902 16.4995 7.49902L20 7.49902M14.9995 2L20 7.49902" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round")
      +e.title.P {{ _('Перетащите сюда файл или') }}
        label(:for='name') {{ _('выберите его') }}
      +e.text.SPAN {{ _('.jpg. .png') }}
  +e.button-load(v-if='localImage')
    +b.tt-button.--bordered_main.--auto.LABEL(
      :for='name'
      @click='toggleShow'
      style='min-height: 47px'
    )
      +e.title.SPAN {{ _('Изменить')}}
</template>

<script>

import Clipper from '@app/Staff/Components/Clipper'

const DEFAULT_SIZE = 200
const DEFAULT_RATIO = 1

export default {
  name: 'ResultLoader',
  props: {
    name: {},
    titles: {},
    img: {},
    type: {
      default: () => 'avatar',
    },
    width: {
      default: () => DEFAULT_SIZE,
    },
    height: {
      default: () => DEFAULT_SIZE,
    },
    method: {
      default: () => 'POST',
    },
    ratio: {
      default: () => DEFAULT_RATIO,
    },
    rate: {
      default: () => DEFAULT_RATIO,
    },
    postResource: {},
    deleteResource: {},
    additional: {},
    initial: {},
    filekey: {
      default: 'img',
    },
  },
  data() {
    return {
      file: this.initial || null,
      localImage: this.initial && window.URL.createObjectURL(this.initial) || null,
      isDragOver: false,
    }
  },
  methods: {
    handleDragOver(event) {
      event.preventDefault();
      this.isDragOver = true;
      // Добавим следующую строку, чтобы предотвратить открытие изображения в новой вкладке
      event.dataTransfer.dropEffect = 'copy';
    },
    handleDragLeave() {
      this.isDragOver = false;
    },
    handleDrop(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.toggleShow(files[0])
    },
    toPromise(file) {
      if (!file) return Promise.reject()

      return Promise.resolve({
        file, img: window.URL.createObjectURL(file),
      })
    },
    load(element) {
      if (this.postResource) {
        this.postResource.execute({}, {
          ...this.additional, [this.filekey]: element,
        }).then(({ data: { item: { id } } }) => {
          this.$emit('update', id)
        })
        return
      }
      this.$emit('update', element)
    },
    toggleShow(imgfile) {
      const preview = window.URL.createObjectURL(imgfile)
      const pr = f => this.toPromise(f)
        .then(({ file, img }) => {
          this.file = file
          this.localImage = img
          this.load(file)
          this.$emit('completed', { key: 'img', value: file })
        })
        .catch(err => {
          this.$emit('error', err)
        })

      this.$modal.show(
        Clipper,
        {
          promise: pr,
          type: this.type,
          w: this.width,
          h: this.height,
          method: this.method,
          ratio: this.ratio,
          rate: this.rate,
          preview,
        },
        {
          height: 'auto',
          classes: 'loadPopup',
          adaptive: true,
          scrollable: true,
        }
      )
    },
  },
}
</script>
